import {forwardRef,useEffect,useRef} from "react"
import AirDatepicker from "air-datepicker"
import "../assets/air-datepicker.css"
import localeEs from "air-datepicker/locale/es"
import calendar from "../assets/calendar.svg"

const Datepicker=forwardRef(({label,val,setVal},ref)=>{
    // Ref para guardar la instancia del datepicker
    const datepickerInstance = useRef(null)

    const change=(event)=>{
        setVal(event.target.value)
    }

    useEffect(()=>{
        if(val===""){
            ref.current.classList.remove("datepicker-textbox-on")
        }else{
            ref.current.classList.add("datepicker-textbox-on")
        }
    },[val,ref])

    useEffect(()=>{
        let datepicker=new AirDatepicker(ref.current,{
            locale:localeEs,
            isMobile:true,
            dateFormat:"dd/MM/yyyy",
            autoClose:true,
            buttons:["clear"],
            onSelect:({formattedDate})=>{
                if(formattedDate===undefined){
                    setVal("")
                }else{
                    setVal(formattedDate)
                }
            }
        })
        datepickerInstance.current = datepicker
        
        // Cleanup: destruir instancia cuando se desmonte
        return () => {
            if(datepickerInstance.current){
                datepickerInstance.current.destroy()
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    
    // Sincronizar el datepicker cuando val cambie desde fuera
    useEffect(()=>{
        if(datepickerInstance.current && val){
            // Parsear la fecha dd/MM/yyyy
            const parts = val.split('/')
            if(parts.length === 3){
                const day = parseInt(parts[0], 10)
                const month = parseInt(parts[1], 10) - 1
                const year = parseInt(parts[2], 10)
                const date = new Date(year, month, day)
                // Actualizar la instancia del datepicker
                datepickerInstance.current.selectDate(date, {silent: false})
            }
        } else if(datepickerInstance.current && val === ""){
            // Si val está vacío, limpiar el datepicker
            datepickerInstance.current.clear()
        }
    },[val])

    return(
        <div className="datepicker">
            <input ref={ref} className="datepicker-textbox" value={val} placeholder={label} onChange={change} />
            <div className="datepicker-icon"><img src={calendar} alt="calendar" /></div>
        </div>
    )
    
})

export default Datepicker